import { Button, Classes, Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { BottomActionContainer } from "@/components/pieces/interaction/BottomActionContainer";
import { BRAND_PURPLE } from "@/css/constants";

import { EnterPrompt } from "./EnterPrompt";

interface CtaButtonProps extends React.ComponentProps<typeof Button> {
  visible: boolean;
  floating?: boolean;
  maxWidth?: string;
  enterDisabled?: boolean;
}

export function CtaButton({
  visible,
  floating,
  maxWidth,
  enterDisabled,
  ...btnProps
}: CtaButtonProps) {
  const floatingButton = (
    <>
      <Box pt={5} pb={3} />
      <BottomActionContainer visible={visible}>
        <Flex margin="0 auto" maxWidth={maxWidth} alignItems="center">
          <Flex width="100%" minWidth={180} justifyContent="center">
            <OnboardButton
              {...btnProps}
              intent="primary"
              large={true}
              fill={true}
            />
          </Flex>
          {!enterDisabled ? (
            <Media greaterThan="xs">
              <EnterPrompt />
            </Media>
          ) : null}
        </Flex>
      </BottomActionContainer>
    </>
  );

  return (
    <>
      <Media greaterThan="xs">
        {visible ? (
          floating ? (
            floatingButton
          ) : (
            <Flex mt={5} alignItems="center" style={{ fontSize: 20 }}>
              <StyledButton intent="primary" {...btnProps} />
              {!enterDisabled ? <EnterPrompt /> : null}
            </Flex>
          )
        ) : null}
      </Media>

      <Media at="xs">{floatingButton}</Media>
    </>
  );
}

export const OnboardButton = styled(Button)`
  &.${Classes.BUTTON} {
    background-color: ${BRAND_PURPLE} !important;
    color: ${Colors.WHITE} !important;
    transition: opacity 100ms ease;
    :hover,
    :focus {
      opacity: 0.9;
    }
    :disabled {
      opacity: 0.5;
    }
    .${Classes.SPINNER} {
      .${Classes.SPINNER_HEAD} {
        stroke: #fff;
      }
      .${Classes.SPINNER_TRACK} {
        stroke: rgba(255, 255, 255, 0.2);
      }
    }
  }
`;

export const StyledButton = styled(OnboardButton)`
  &.${Classes.BUTTON} {
    height: 50px;
    font-size: 20px;
    padding: 0 50px;
  }
`;
